import { useSearchParams } from 'react-router-dom';

import PageHeader from '@/components/PageHeader';
import { Button } from '@/ui';
import Container from '@/ui/components/Container';

import { AllPeople, MyPeople } from './components';

enum PeopleTab {
  MY_PEOPLE = 'my-people',
  ALL_PEOPLE = 'all-people'
}

const People = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') ?? PeopleTab.MY_PEOPLE;

  const handleTabChange = (newTab: PeopleTab) => {
    setSearchParams((currentParams) => {
      if (newTab !== PeopleTab.MY_PEOPLE) {
        currentParams.set('tab', newTab);
      } else {
        currentParams.delete('tab');
      }
      // Reset page and search when switching tabs
      currentParams.delete('page');
      currentParams.delete('search');
      return currentParams;
    });
  };

  return (
    <Container type="page">
      <PageHeader headingText="People" className="sr-only" />

      <div className="border-b pb-1 border-gray-300 mb-4 w-full">
        <div className="flex justify-start gap-2 mb-2">
          <Button
            className="capitalize"
            size="xs"
            variant={activeTab === PeopleTab.MY_PEOPLE ? 'default' : 'outline'}
            color={activeTab === PeopleTab.MY_PEOPLE ? 'secondary' : 'neutral'}
            onClick={() => handleTabChange(PeopleTab.MY_PEOPLE)}>
            My People
          </Button>
          <Button
            className="capitalize"
            size="xs"
            variant={activeTab === PeopleTab.ALL_PEOPLE ? 'default' : 'outline'}
            color={activeTab === PeopleTab.ALL_PEOPLE ? 'secondary' : 'neutral'}
            onClick={() => handleTabChange(PeopleTab.ALL_PEOPLE)}>
            All People
          </Button>
        </div>
      </div>

      {/* Tab Content */}
      {activeTab === PeopleTab.MY_PEOPLE && <MyPeople />}
      {activeTab === PeopleTab.ALL_PEOPLE && <AllPeople />}
    </Container>
  );
};

export default People;
